import * as angular from 'angular';
import { PowerBiClientFactory } from './PowerBiClientFactory';

let powerBiClientModule = angular.module('app.areas.common.powerBiClient', []);

powerBiClientModule.factory(PowerBiClientFactory.$name, PowerBiClientFactory);

// Must run to enforce no use of global powerbi-client variable
// tslint:disable-next-line: no-empty
powerBiClientModule.run(['powerBiClient', (powerBiClient: any) => { }]);

export default powerBiClientModule.name;
